import { CUSTOM_EVENT } from '../config';

export class Menu {
  static CLASS_OPEN = 'is-open';

  // =============================================================================
  // Lifecycle
  // =============================================================================
  static init() {
    const items = document.querySelectorAll('[data-menu="item"]');
    const listItem = document.querySelectorAll('.c-menu_item_list_link');
    const menu = document.querySelector('.c-menu');

    listItem.forEach(item => {
      item.addEventListener('click', () => {
        document.documentElement.classList.remove('has-modal-open', 'has-menu-open');
        menu?.classList.remove('is-active');
        Menu.reset();
      });
    });

    if (!items.length) return;

    const allDetails = [...items]
      .map(el => el.querySelector('[data-menu="details"]'))
      .filter(Boolean);

    items.forEach(item => {
      const parent =
        item.closest('[data-menu-parent]') || document.querySelector('[data-menu-parent]');
      if (!parent) return;

      const handleEnter = () => {
        item.classList.add('is-active');
        parent.classList.add('is-active');
      };

      const handleLeave = () => {
        item.classList.remove('is-active');

        if (!parent.querySelector('[data-menu="item"].is-active')) {
          parent.classList.remove('is-active');
        }
      };

      item.addEventListener('mouseenter', handleEnter);
      item.addEventListener('mouseleave', handleLeave);

      const details = item.querySelector('[data-menu="details"]');
      const trigger = item.querySelector('[data-menu="trigger"]');

      if (details && trigger) {
        trigger.addEventListener('click', e => {
          e.preventDefault();
          Menu.toggle(details, item, allDetails);
        });
      }
    });

    window.addEventListener(CUSTOM_EVENT.VISIT_START, Menu.reset);
  }

  // =============================================================================
  // Details (аккордеон на мобилке)
  // =============================================================================
  static open(details, item) {
    if (!details || !item) return;

    details.classList.add(Menu.CLASS_OPEN);
    item.classList.add(Menu.CLASS_OPEN);
  }

  static close(details, item) {
    if (!details || !item) return;
    details.classList.remove(Menu.CLASS_OPEN);
    item.classList.remove(Menu.CLASS_OPEN);
  }

  static toggle(details, item, allDetails = []) {
    if (!details || !item) return;

    if (details.classList.contains(Menu.CLASS_OPEN)) {
      Menu.close(details, item);
    } else {
      allDetails.forEach(d => {
        if (d !== details) {
          const otherItem = d.closest('[data-menu="item"]');
          Menu.close(d, otherItem);
        }
      });
      Menu.open(details, item);
    }
  }

  /**
   * Сбрасывает все открытые пункты (is-open) и вызывается при закрытии меню или переходе на другую страницу.
   */
  static reset() {
    document.querySelectorAll('[data-menu="details"]').forEach(el => {
      el.classList.remove(Menu.CLASS_OPEN);
    });
    document.querySelectorAll('[data-menu="item"]').forEach(el => {
      el.classList.remove(Menu.CLASS_OPEN);
    });
  }
}
